import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { CatalogItemsSort } from '../../api/def_client_api';
import { ICatalog } from '../../shared/types/catalog';
import { ICatalogItem } from '../../shared/types/catalog-items';

import { fetchCatalog, fetchCatalogItems } from './catalog.actions';
import { CatalogPageState } from './catalog.interface';

const initialState: CatalogPageState = {
  catalog: {
    navigation: [],
  },
  catalogItems: null,
  newItemsLength: 0,
  priceKopecksMin: 0,
  priceKopecksMax: 30000000,
  limit: 30,
  offset: 0,
  showMoreButton: false,
  loading: false,
  offsetHeight: [],
  switchActive: 'grid',
  visibleCatalogMenu: false,
  visibleMobileMenu: false,
  isChange: false,
  selectSort: CatalogItemsSort.UpdatedDesc,
  priceValue: [0, 300000],
  availabilityOrNo: {
    availability: true,
    no: false,
  },
};

export const catalogPageSlice = createSlice({
  name: 'catalogPageSlice',
  initialState,
  reducers: {
    setPriceKopecksMax(state, action: PayloadAction<number>) {
      state.priceKopecksMax = action.payload;
    },
    setPriceKopecksMin(state, action: PayloadAction<number>) {
      state.priceKopecksMin = action.payload;
    },
    setLimit(state, action: PayloadAction<number>) {
      state.limit += action.payload;
    },
    setOffset(state, action: PayloadAction<number>) {
      state.offset = action.payload;
    },
    setCatalogItems(state, action: PayloadAction<ICatalogItem[]>) {
      state.catalogItems = action.payload;
    },
    setNewItemsLength(state, action: PayloadAction<number>) {
      state.newItemsLength = action.payload;
    },
    setShowMoreButton(state, action: PayloadAction<boolean>) {
      state.showMoreButton = action.payload;
    },
    setOffsetHeight(state, action: PayloadAction<any[]>) {
      state.offsetHeight = action.payload;
    },
    setSwitchActive(state, action: PayloadAction<'list' | 'grid'>) {
      state.switchActive = action.payload;
    },
    setVisibleCatalogMenu(state, action: PayloadAction<boolean>) {
      state.visibleCatalogMenu = action.payload;
    },
    setVisibleMobileMenu(state, action: PayloadAction<boolean>) {
      state.visibleMobileMenu = action.payload;
    },
    setIsChange(state, action: PayloadAction<boolean>) {
      state.isChange = action.payload;
    },
    setSelectSort(state, action: PayloadAction<CatalogItemsSort>) {
      state.selectSort = action.payload;
    },
    //Изменение цены - больше либо меньше
    setPriceValue(state, action: PayloadAction<number[]>) {
      state.priceValue = action.payload;
    },
    //Состояние "в наличии" и "нет в наличии"
    setAvailabilityOrNo(state, action: PayloadAction<any>) {
      state.availabilityOrNo = action.payload;
    },
  },
  extraReducers: {
    [fetchCatalog.fulfilled.type]: (state, action: PayloadAction<ICatalog>) => {
      state.catalog = action.payload;
    },
    [fetchCatalogItems.pending.type]: (state) => {
      state.loading = true;
    },
    [fetchCatalogItems.fulfilled.type]: (
      state,
      action: PayloadAction<ICatalogItem[]>
    ) => {
      let firstItem: boolean | null = false;
      if (action.payload.length !== 0) {
        firstItem =
          state.catalogItems &&
          state?.catalogItems[state.catalogItems.length - 1]?.id !==
            action.payload?.[action.payload.length - 1]?.id;
      }
      if (!state.showMoreButton || state.isChange) {
        state.catalogItems = action.payload;
      }
      if (
        action.payload.length !== 0 &&
        state.showMoreButton &&
        !state.isChange &&
        state.catalogItems &&
        firstItem
      ) {
        // @ts-ignore
        state.catalogItems = [...state.catalogItems, ...action.payload];
      }
      if (action.payload.length === 0) {
        state.catalogItems = [];
      }
      state.loading = false;
      state.newItemsLength = action.payload.length;
    },
  },
});
export const catalogActions = catalogPageSlice.actions;
export const { reducer } = catalogPageSlice;
